import React, { Component } from "react";
import PropTypes from "prop-types";
import { Body } from "MODULES/shared/components/Modal";
import { ModalFooter } from "react-bootstrap";
import { DO_NOT_LIST, LIST } from "MODULES/inventories/constants";
import {
  LocationFlag,
  NoteTooltip as IconTooltip
} from "MODULES/shared/components";
import MultiLocationFeature from "MODULES/shared/components/MultiLocationFeature/MultiLocationFeature";
import { StoreOwnerWarning } from "MODULES/SalesOrders/components/ConvertFromCartForm/Warnings";

class Form extends Component {
  static propTypes = {
    convertQuote: PropTypes.func.isRequired,
    inventories: PropTypes.arrayOf(PropTypes.number),
    close: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    quote: PropTypes.shape({}).isRequired
  };

  state = {
    selectedLineItems: [],
    selectAll: false
  };

  onItemSelected = lineItem => {
    if (lineItem.id === null) {
      return;
    }

    const { selectedLineItems } = this.state;
    const array = [...selectedLineItems];
    const index = array.indexOf(lineItem);
    if (index !== -1) {
      array.splice(index, 1);
      this.setState({ selectedLineItems: array, selectAll: false });
    } else {
      this.setState({
        selectedLineItems: selectedLineItems.concat([lineItem])
      });
    }
  };

  selectAll = () =>
    this.setState({
      selectedLineItems: this.props.inventories.filter(i =>
        [LIST, DO_NOT_LIST].includes(i.sellable_status)
      ),
      selectAll: true
    });

  renderRow = (lineItem, i) => (
    <tr key={i}>
      <td>{i + 1}</td>
      <td style={{ marginBottom: "6px" }}>
        {[LIST, DO_NOT_LIST].includes(lineItem.sellable_status) ? (
          <input
            name="line_items"
            type="checkbox"
            checked={this.state.selectedLineItems.includes(lineItem)}
            onChange={() => this.onItemSelected(lineItem)}
          />
        ) : (
          <IconTooltip
            icon={"fa-lock"}
            placement={"top"}
            note={"Unavailable"}
            color="rgba(255, 255, 255, 0.25)"
          />
        )}
      </td>
      <td>{lineItem.part.part_number}</td>
      <td>{lineItem.serial_number}</td>
      <td>{lineItem.location}</td>
      <MultiLocationFeature>
        <td className="text-center">
          <LocationFlag location={lineItem.store_location_id} />
        </td>
        <td className="text-center">
          <LocationFlag location={lineItem.store_owner_id} />
        </td>
      </MultiLocationFeature>
    </tr>
  );

  render() {
    const {
      close,
      convertQuote,
      handleSubmit,
      inventories,
      quote
    } = this.props;
    const { selectedLineItems } = this.state;

    const sameStoreOwner = [0, 1].includes(
      [...new Set(selectedLineItems.map(a => a.store_owner_id))].length
    );

    return (
      <form onSubmit={handleSubmit}>
        <Body>
          <MultiLocationFeature>
            {!sameStoreOwner && <StoreOwnerWarning />}
          </MultiLocationFeature>
          <table className="table table-striped table-hover table-numbered">
            <thead>
              <tr>
                <th />
                <th>
                  <input
                    name="line_items"
                    type="checkbox"
                    onChange={this.selectAll}
                    checked={this.state.selectAll}
                  />
                  &nbsp;&nbsp;Select All
                </th>
                <th>Part Number</th>
                <th>Serial Number</th>
                <th>Location</th>
                <MultiLocationFeature>
                  <th className="text-center">Store Location</th>
                  <th className="text-center">Store Owner</th>
                </MultiLocationFeature>
              </tr>
            </thead>
            <tbody>
              {inventories.map((inv, idx) => this.renderRow(inv, idx))}
            </tbody>
          </table>
        </Body>
        <ModalFooter>
          <button type="button" className="btn btn-default" onClick={close}>
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-success"
            disabled={!sameStoreOwner}
            onClick={() => {
              convertQuote({
                inventory_ids: selectedLineItems.map(s => s.id),
                outgoing_quote_id: quote.id
              });
            }}
          >
            Continue
          </button>
        </ModalFooter>
      </form>
    );
  }
}

export default Form;



// WEBPACK FOOTER //
// ./app/modules/OutgoingQuotes/Detail/ConvertToSalesOrder/Form.jsx